import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "autosave-display";

const keys = addTranslations(RESOURCE_NAME, {
    autosave_display: {
        en: "Saving...",
        fr: "Enregistrement...",
    },
    autosave_display_pending: {
        en: "Saving...",
        fr: "Enregistrement...",
    },
    autosave_display_success: {
        en: "Saved",
        fr: "Enregistré",
    },
});

export function useAutosaveDisplayTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
